<template>
	<div
		class="yasduoe"
		:style="computedStyle"
		v-if="messages && messages.length > 0"
	>
		<div
			v-for="(item, i) in messages"
			v-if="i < max"
			:key="i"
			:class="item.type ? item.type : 'neutral'"
			class="message"
			tabindex="0"
			@keypress.enter="$emit('click', item)"
			@blur="$emit('blur')"
			@focus="$emit('focus')"
		>
			<!-- Text -->
			{{ item.text }}

			<!-- If there is a link -->
			<router-link
				v-if="item.link"
				:to="item.link.to"
				@click.native="$emit('click', item)"
				class="link"
			>
				{{ item.link.text }}
			</router-link>

			<!-- Close -->
			<div class="close" @click="$emit('click', item)">
				✕
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "j-message",
	props: {
		messages: {
			validator(val) {
				return val === null || val instanceof Array
			},
			default: () => [],
			required: false
			/**
			 * Example:
			 * [{ type: "neutral", text:"I am a message", link: { text: "Hello I'm link", to:"/somewhere"} }]
			 */
		},
		max: {
			type: Number,
			default: 5,
			required: false
		},
		zIndex: {
			type: Number,
			required: false,
			default: 100
		}
	},
	computed: {
		computedStyle() {
			return `z-index: ${this.zIndex}`
		}
	}
}
</script>
<style src="./index.css" scoped />
